import { useState } from "react";
import { NewInput, NewSelect } from "../../BaseComponents";
import { NewFieldStyles, NewFieldTypes, SelectFieldOption_Values } from "../../../Definitions";
import { colors, css, fonts, glyphs, useMediaQuery } from "../../../Styles";
import FeedCorrectionPopover from "./feedCorrectionPopover";
import FeedSkipPopover from "./feedSkipPopover";

/* eslint-disable */
export enum FieldMode {
  select = "select",
  input = "input",
  feedCorrection = "feedCorrection",
  feedSkip = "feedSkip"
}
/* eslint-enable */

type BaseProps = {
  editContent?: undefined | JSX.Element;
  header: string;
  enhancer: string | JSX.Element
  content: string | number | undefined | JSX.Element;
  noContent: string | number | undefined
  focusView?: boolean;
  editMode?: boolean;
};

export default function NewLineInfoDisplay(props: BaseProps) {
  const { header, enhancer, focusView, editMode, editContent, content, noContent } = props;

  return (
    <div style={{ ...css.basic_Info_style, ...fonts.fontSize3, width: "100%", maxWidth: "320px", gridTemplateColumns: "7fr 25px 8fr" }}>
      <div style={{ gridArea: "1/1/2/2", ...css.basicInfo_rightStyle, marginRight: "10px", height: focusView ? "40px" : "25px" }}>{header}</div>
      <div style={{ gridArea: "1/2/2/3", ...css.basicInfo_centerStyle, height: focusView ? "40px" : "25px" }}>{enhancer}</div>
      <div style={{ gridArea: "1/3/2/4", ...css.basicInfo_leftStyle, marginLeft: editMode ? "5px" : "10px", height: focusView ? "40px" : "25px" }}>
        {editMode ? editContent : (noContent !== undefined) ? <span style={{ opacity: "0.5", fontStyle: "italic" }}>{noContent}</span> : content}
      </div>
    </div>
  )
  }
